export function RadioOutlineIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clip-path="url(#clip0_590_35465)" className={className}>
        <rect x="0.7515" y="0.7515" width="16.497" height="16.497" rx="8.2485" stroke="#98A2B3" stroke-width="1.503" />
      </g>
      <defs>
        <clipPath id="clip0_590_35465">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

RadioOutlineIcon.displayName = 'RadioOutlineIcon';
